<div *ngIf="testHTML != null" class="bg-beige-tricon p-8" [innerHTML]="testHTML"></div>    
